import { gql } from '@apollo/client'

export const KYC_STATUS_BRIEF_FRAGMENT = gql`
    fragment KycStatusBrief on KycStatus {
        id
        signature
        cognitoKycFlow {
            id
            status
            userCompleted
            completed_at
        }
    }
`

gql`
    mutation KycStatusSetUserCompleted {
        kycStatusSetUserCompleted {
            ...KycStatusBrief
        }
    }
`

gql`
    mutation UpdateMethodfiSSN($ssn: String!) {
        methodFiUpdateSSN(ssn: $ssn) {
            ...FullMethodFiEntity
        }
    }
`

gql`
    query VerificationData {
        me {
            id
            email
            kycStatus {
                ...KycStatusBrief
            }
            methodFiEntity {
                ...FullMethodFiEntity
            }
        }
    }
`
